<template>
  <van-steps direction="vertical" :active="1">
    <van-step v-for="item in list">
      <h4>审核类型：{{ item.auditType | filterAuditType }}</h4>
      <h4>审核结果：{{ item.auditStatus | filterAuditStatus }}</h4>
      <h4>处理人：{{ item.auditPerson }}</h4>
      <div style="font-weight: bold; white-space: pre-wrap" v-html="item.auditRemark"></div>
      <p style="font-weight: bold">{{ item.createDateStr }}</p>
    </van-step>
  </van-steps>
</template>

<script>

import {getComments} from '@/api/loanInfo'

export default {
  name: 'records',
  components: {},
  props: {
    applyId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      let params = {
        applyId: this.applyId
      }
      console.log(this.applyId)
      getComments(params).then(res => {

        if (res.data) {
          this.list = res.data
        }

      })
    }
  }
}
</script>

<style scoped>

</style>
